var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"horizontal-stepper-label-step",class:_vm.classes},[_c('div',{staticClass:"horizontal-stepper-label-step__number"},[_vm._v(_vm._s(_vm.number))]),_c('div',{staticClass:"horizontal-stepper-label-step__text"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }